import Embed from "@editorjs/embed";
import Table from "@editorjs/table";
import Paragraph from "@editorjs/paragraph";
import List from "@editorjs/list";
import Warning from "@editorjs/warning";
import Code from "@editorjs/code";
import LinkTool from "@editorjs/link";
import Image from "@editorjs/image";
// import Raw from "@editorjs/raw";
import Header from "@editorjs/header";
// import Quote from "@editorjs/quote";
import CheckList from "@editorjs/checklist";
import Delimiter from "@editorjs/delimiter";
import InlineCode from "@editorjs/inline-code";
import SimpleImage from "@editorjs/simple-image";
import { ACCESS_TOKEN } from "../../lib/cookie";
import { postEditorImage } from "../../api/postAPI";
import { ColorInlineTool } from "./plugin/inlineExecStyleTool";


export const EDITOR_JS_TOOLS = (postId) => ({
  paragraph: {
    class: Paragraph,
    inlineToolbar: true,
    config: {
      preserveBlank: true,
    },
  },

  embed: Embed,
  table: Table,
  
  list: {
    class: List,
    inlineToolbar: true,
    config: {
      defaultStyle: "unordered",
    },
  },
  // warning: Warning,
  // code: Code,
  // linkTool: LinkTool,
  image: {
    class: Image,
    config: {
      additionalRequestHeaders: {
        Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
      },
      uploader: {
      uploadByFile(file) {
        return postEditorImage(postId, file);
      },
    },
    },
  },
  // raw: Raw,
  header: {
    class: Header,
    inlineToolbar: true,
  },
  // quote: {
  //   class: Quote,
  //   // inlineToolbar: true,
  // },
  checklist: {
    class: CheckList,
    inlineToolbar: true,
  },
  delimiter: Delimiter,
  inlineCode: InlineCode,
  simpleImage: SimpleImage,

  /** ==========================
   *       Plug-in 추가
   ============================ */
  // 통합 색 메뉴 (Notion 스타일): 하나의 버튼 → 최근 사용 / 텍스트 색상 / 배경 색상
  color: {
    class: ColorInlineTool,
  },
});